module.exports = __webpack_public_path__ + "media/images/samples/members/news-1-b0bc3d41f34b3456d41d9ac949d6609b.png";